/*
 * @Descripttion: actions
 * @Author: juanjuanhui
 * @Date: 2021-08-06 14:23:07
 * @LastEditors: quwandong
 * @LastEditTime: 2022-07-07 14:22:08
 */
import * as types from "./types";
const actions = {
  /**
   * @descripttion: 获取登录信息
   * @Author: juanjuanhui
   * @Date: 2021-12-13 10:07:43
   */
  getUserInfo({ commit }, payload = {}) {
    commit(types.GET_USER_INFO, payload);
  },
  /**
   * @descripttion: 获取token
   * @Author: juanjuanhui
   * @Date: 2021-12-13 10:39:03
   */
  getAccesToken({ commit }, payload) {
    commit(types.GET_ACCESS_TOKEN, payload);
  },
  // 控制左侧菜单是否显示
  setIsShowSideBar({ commit }, payload) {
    commit("setIsShowSideBar", payload);
  },
  // 标记头部菜单对应path
  setHeadMenu({ commit }, payload) {
    commit("setHeadMenu", payload);
  },
};
export default actions;
